import { useEffect, useState } from "react";
import { useLocalStorageState } from "../../../../../hooks/useLocalStorageState";
import {
  INTEGRATION_SYNC_ALL_KEY,
  INTEGRATION_SYNC_NEW_KEY,
  REFETCH_INTERVAL_MS,
  UNKNOWN_AUTHORIZATION_DATE,
} from "../config";
import { useConstantContactAuthDataQuery } from "../../../../../api/constantContact/useConstantContactAuthDataQuery";
import { uiNotification } from "../../../../../services/UINotificationService";
import { useSaveConstantContactAuthDataMutation } from "../../../../../api/constantContact/useSaveConstantContactAuthDataMutation";

const parseBoolean = (value) => {
  return value === "true";
};

export function useIntegration() {
  const [isEnabled, setIsEnabled] = useState(false);
  const [url, setUrl] = useState("");
  const [date, setDate] = useState(null);
  const [enableRefetchInterval, setEnableRefetchInterval] = useState(false);

  const { mutateAsync: saveIntegrationData } =
    useSaveConstantContactAuthDataMutation({
      onError: () => {
        uiNotification.error(
          "Unable to save integration data. Try again later.",
        );
      },
    });

  const [syncAll, setSyncAll] = useLocalStorageState(
    INTEGRATION_SYNC_ALL_KEY,
    false,
    {
      transform: parseBoolean,
      enableInit: true,
    },
  );

  const [syncNew, setSyncNew] = useLocalStorageState(
    INTEGRATION_SYNC_NEW_KEY,
    false,
    {
      transform: parseBoolean,
      enableInit: true,
    },
  );

  const { isLoading } = useConstantContactAuthDataQuery({
    refetchInterval: enableRefetchInterval ? REFETCH_INTERVAL_MS : false,
    refetchIntervalInBackground: enableRefetchInterval,
    onError: () => {
      uiNotification.error(
        "Unable to fetch integration data. Try again later.",
      );
    },
    onSuccess: (data) => {
      const enabled = Boolean(data.accessToken);
      if (!enabled && !enableRefetchInterval) {
        setIsEnabled(false);
      }
      if (enabled) {
        setIsEnabled(true);
      }
      setUrl(data.url);
      setDate(enabled ? data.date || UNKNOWN_AUTHORIZATION_DATE : null);
      setSyncAll(data.syncAll);
      setSyncNew(data.syncNew);
    },
  });

  const onAuthorize = () => {
    setEnableRefetchInterval(true);
    window.open(
      url,
      "Ratting",
      "width=550,height=550,left=150,top=200,toolbar=0,status=0,scrollbars=1",
      "_blank",
    );
  };

  const handleIsEnabled = (next) => {
    const next_ = typeof next === "function" ? next(isEnabled) : next;
    if (next_) {
      setIsEnabled(true);
    } else {
      setIsEnabled(false);
      setEnableRefetchInterval(false);
      saveIntegrationData({
        accessToken: "",
        saveAll: false,
        saveNew: false,
      }).catch(() => {
        setIsEnabled(true);
      });
    }
  };

  useEffect(() => {
    if (!isEnabled) {
      setEnableRefetchInterval(false);
    }
  }, [isEnabled]);

  return {
    isEnabled,
    setIsEnabled: handleIsEnabled,
    syncAll,
    setSyncAll,
    syncNew,
    setSyncNew,
    isLoading,
    date,
    onAuthorize,
  };
}
